/**
 * Constantes y utilidades para gestión de roles
 */

/**
 * Roles que tienen acceso al Dashboard completo del sistema
 */
export const ADMIN_ROLES: string[] = ['SuperAdmin', 'Administrador'];

/**
 * Verifica si un rol tiene permisos de administrador (acceso al Dashboard)
 * @param roleName Nombre del rol a verificar
 * @returns true si el rol es admin, false en caso contrario
 */
export const isAdminRole = (roleName: string | null | undefined): boolean => {
  if (!roleName) return false;
  return ADMIN_ROLES.includes(roleName);
};

